// Selectors
export const selectKeyBindings = s => s.key_bindings.bindings
export const selectKeyBindingConflicts = s => s.key_bindings.conflicts
export const selectEditingBinding = s => s.key_bindings.editing
